
import environment from '@/untils/environment';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CreateSuccess',
  data() {
    return {
      time: 10,
    };
  },
  mounted() {
    setTimeout(async () => {
      console.log(123);
      const accountId = await localStorage.getItem('accountId');
      const memberId = await localStorage.getItem('memberId');
      const token = await localStorage.getItem('token');
      const siteId = await localStorage.getItem('siteId');
      const store = (this as any).$store;
      const loc = window.location;
      const uri = loc.host;
      const url = `http://${uri.indexOf('pre') === -1 ? 'hdsupport.saas.seatent.com' : 'hdsupport.saas.saaspre.seatent.com'}/#/callback?randomCode=42rfmhh9x73juwvw&approach=22&token=${token}&accountId=${accountId}&appkey=${environment.appkey}&siteId=${siteId}&memberId=${memberId}&link=/home/go&isNew=${store.state.isNew}`;
      console.log(url);
      store.state.isNew = 0;
      window.location.href = url;
    }, 10000);
    const timer = setInterval(() => {
      if (this.time === 0) {
        clearInterval(timer);
      } else {
        this.time -= 1;
      }
    }, 1000);
  },
  components: {
  },
  methods: {
  },
});
